<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  catalog: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const laudemios = computed(() => props.catalog.property?.laudemios || []);
</script>

<template>
  <section class="grid gap-4">
    <h2 class="text-lg font-semibold text-lais-text">
      {{
        laudemios.length
          ? t('POST_SALE.TOPICS.LAUDEMIUM.REGISTERED')
          : t('POST_SALE.TOPICS.LAUDEMIUM.MISSING')
      }}
    </h2>
    <label
      v-if="laudemios.length"
      class="grid gap-1 text-sm font-semibold text-lais-text-body"
    >
      {{ t('POST_SALE.TOPICS.LAUDEMIUM.COUNT') }}
      <input
        :value="laudemios.length"
        class="min-h-10 rounded-lais border border-lais-border bg-lais-bg-soft px-2 font-normal"
        readonly
      />
    </label>
    <div
      v-for="(laudemio, index) in laudemios"
      :key="laudemio.id || index"
      class="grid gap-4 rounded-lais border border-lais-border-soft p-4 sm:grid-cols-2"
    >
      <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
        {{ t('POST_SALE.TOPICS.LAUDEMIUM.TYPE') }}
        <input
          :value="laudemio.tipo_nome"
          class="min-h-10 rounded-lais border border-lais-border bg-lais-bg-soft px-2 font-normal"
          readonly
        />
      </label>
      <label
        v-if="laudemio.valor_label"
        class="grid gap-1 text-sm font-semibold text-lais-text-body"
      >
        {{
          laudemio.tipo_laudemio === '1'
            ? t('POST_SALE.TOPICS.LAUDEMIUM.FIELDS.1')
            : laudemio.tipo_laudemio === '3'
              ? t('POST_SALE.TOPICS.LAUDEMIUM.FIELDS.3')
              : t('POST_SALE.TOPICS.LAUDEMIUM.FIELDS.4')
        }}
        <input
          :value="laudemio.valor_nome"
          class="min-h-10 rounded-lais border border-lais-border bg-lais-bg-soft px-2 font-normal"
          readonly
        />
      </label>
    </div>
  </section>
</template>
